import React from 'react';
import connect from 'react-redux/es/connect/connect';
import PropTypes from 'prop-types';
import {Button, CustomInput, Dropdown, DropdownMenu, DropdownToggle, Row, Col} from 'reactstrap';
import _keys from 'lodash/keys';
import _merge from 'lodash/merge';
import _isEqual from 'lodash/isEqual';
import _filter from 'lodash/filter';
import OdinCheckbox from '../Forms/OdinCheckbox';
import {popularFeaturesForSearch, saleDateOptions, saleTypeForSearch} from '../../lib/config';
import {updateSearchFilter} from '../../actions';
import styles from './MoreFilters.scss';
import _cloneDeep from 'lodash/cloneDeep';
import TwoWaySlider from './TwoWaySlider';
import moment from 'moment/moment';
import Datetime from 'react-datetime';
import '../../assets/styles/react-datetime.scss';
import CloseIcon from '@material-ui/icons/Close';

const saleTypes = _keys(saleTypeForSearch);
const popularFeatures = _keys(popularFeaturesForSearch);

const MoreFilters = props => {
  const {
    filterSearch,
    updateSearchFilter: updateStoreState,
    searchFunction,
    isHomePage = false,
  } = props;

  const [inputKeyword, setInputKeyword] = React.useState('');
  const [showHistory, setShowHistory] = React.useState(false);
  const [keywordList, setKeywordList] = React.useState([...filterSearch.additionalFeaturesQuery.featureFreeText]);

  React.useEffect(() => {
    // mount
    // show history if status is All or Offmarket
    let statusCount = _filter(filterSearch.propertyStatus).length;
    if (statusCount === 4 || (statusCount === 1 && filterSearch.propertyStatus['off-market'] === true)) setShowHistory(true);
    else setShowHistory(false);
  }, []);

  //update store on keywordList state updates
  React.useEffect(() => {
    if (!_isEqual(filterSearch.additionalFeaturesQuery.featureFreeText, keywordList)) {
      const newState = _merge({}, props.filterSearch);
      newState.additionalFeaturesQuery.featureFreeText = keywordList;
      updateStoreState({...newState});
    }
  }, [keywordList]);

  const updatePopularFeature = (feature) => {
    const newState = _merge({}, filterSearch);
    newState.additionalFeaturesQuery[feature] = !newState.additionalFeaturesQuery[feature];
    updateStoreState({...newState});
  };

  const handleNewOrEstablishedChange = (feature) => {
    const newState = _merge({}, filterSearch);
    newState.additionalFeaturesQuery.isEstablishedHome = false;
    newState.additionalFeaturesQuery.isNewBuild = false;
    if (feature === 'isNewBuild' || feature === 'isEstablishedHome') {
      newState.additionalFeaturesQuery[feature] = true;
    }
    updateStoreState({...newState});
  };

  const addKeyword = () => {
    if (inputKeyword === '') return;
    if (keywordList.length >= 5) return;

    setKeywordList([...filterSearch.additionalFeaturesQuery.featureFreeText, inputKeyword]);
    setInputKeyword('');
  };

  const deleteKeyword = (index) => {
    const currKeywordList = _cloneDeep(filterSearch.additionalFeaturesQuery.featureFreeText);
    setKeywordList(currKeywordList.filter((_, keywordIndex) => keywordIndex !== index));
  };

  const updateBathrooms = (min, max) => {
    const newState = _merge({}, filterSearch);
    if (Number(min) === 0) {
      newState['bathroom']['min'] = null;
    } else {
      newState['bathroom']['min'] = min.toString();
    }

    if (Number(max) === 5 || Number(max) === 0) {
      newState['bathroom']['max'] = null;
    } else {
      newState['bathroom']['max'] = max.toString();
    }

    if (newState.bathroom.min !== filterSearch.bathroom.min || newState.bathroom.max !== filterSearch.bathroom.max) {
      updateStoreState({...newState});
    }
  };

  const updateCars = (min, max) => {
    const newState = _merge({}, filterSearch);
    if (Number(min) === 0) {
      newState['carPark']['min'] = null;
    } else {
      newState['carPark']['min'] = min.toString();
    }

    if (Number(max) === 5 || Number(max) === 0) {
      newState['carPark']['max'] = null;
    } else {
      newState['carPark']['max'] = max.toString();
    }
    if (newState.carPark.min !== filterSearch.carPark.min || newState.carPark.max !== filterSearch.carPark.max) {
      updateStoreState({...newState});
    }
  };

  const updateSaleDate = (soldDateStart) => {
    updateStoreState({...filterSearch, soldDateStart});
  };

  const toggleBooleanValue = (filterType) => {
    let newState = _merge({}, filterSearch);
    newState[filterType] = !newState[filterType];
    updateStoreState(newState);
  };

  const getDateAvailableFrom = () => {
    if (!filterSearch['dateAvailableFrom']) {
      return '';

    } else if (typeof filterSearch['dateAvailableFrom'] === 'string') {
      return moment(filterSearch['dateAvailableFrom']).format('DD-MM-YYYY');

    } else {
      return filterSearch['dateAvailableFrom'].format('DD-MM-YYYY');
    }

  };

  const updateDateAvailableFrom = (date) => {
    let newState = _merge({}, filterSearch);
    newState['dateAvailableFrom'] = date || '';
    updateStoreState(newState);
  };

  const updateSaleType = (saleType) => {
    const newState = _merge({}, filterSearch);
    newState.saleTypes[saleType] = !newState.saleTypes[saleType];
    updateStoreState(newState);
  };

  const disabledKeywordButtonStyle = keywordList.length >= 5 ? styles.disabled : '';
  return (
    <div className={styles.menuWrapper}>
      <Dropdown isOpen={props.isOpen} toggle={(e) => props.toggleFunction(e, 'external')}>
        <DropdownToggle className="d-none"/>
        <DropdownMenu positionFixed className={styles.menu}>
          <div className={`${styles.container} ${isHomePage && styles.overflowVisible}`}>
            {!isHomePage && <div className={styles.searchFilter}>
              <div className={styles.heading}>Baths</div>
              <div className={styles.description}>Select min and max bathrooms</div>
              <TwoWaySlider width="90%" min={0} max={5} initialMin={filterSearch.bathroom.min || 0}
                initialMax={filterSearch.bathroom.max || 5} step={1}
                labels={['Any', '1', '2', '3', '4', '5+']} updateFunction={updateBathrooms}/>
            </div>}


            {!isHomePage && <div className={styles.searchFilter}>
              <div className={styles.heading}>Car</div>
              <div className={styles.description}>Select min and max car</div>
              <TwoWaySlider width="90%" min={0} max={5} initialMin={filterSearch.carPark.min || 0}
                initialMax={filterSearch.carPark.max || 5} step={1}
                labels={['Any', '1', '2', '3', '4', '5+']} updateFunction={updateCars}/>
            </div>}
            {filterSearch.propertyStatus['sold'] && !filterSearch.propertyStatus['for-sale'] && !filterSearch.propertyStatus['for-rent'] && !filterSearch.propertyStatus['off-market'] &&
              <div className={styles.searchFilter}>
                <div className={styles.heading}>Sale Date</div>

                <div className={'d-flex flex-column m-0'}>
                  <Row xs="2" className={'p-0 m-0 ' + styles.saleRow}>
                    {saleDateOptions.map((dateOption, index) =>

                      <Col className="pl-0" key={index}>
                        <Button
                          className={`mb-3 d-flex text-center w-100 justify-content-center ${styles.saleDate} ${filterSearch.soldDateStart === dateOption.label && styles.saleDateActive}`}
                          outline
                          active={filterSearch.soldDateStart === dateOption.label} value={dateOption.label}
                          name="saleDate"
                          onClick={() => updateSaleDate(dateOption.label)}
                        >
                          {dateOption.label}
                        </Button>
                      </Col>
                    )}
                  </Row>
                </div>
              </div>
            }
            {!filterSearch.propertyStatus['off-market'] && !filterSearch.propertyStatus['sold'] &&
              <div className={styles.searchFilter}>
                <div className={styles.heading}>Popular Features</div>
                <div className={styles.featureList}>
                  {popularFeatures.map((feature, index) =>
                    <div className={`mb-2 ${styles.listItem}`} key={index}>
                      <OdinCheckbox
                        id={`moreFiltersPopularFeatures ${feature}`}
                        checked={filterSearch.additionalFeaturesQuery[feature]}
                        onChange={() => updatePopularFeature(feature)}
                      />
                      <label className="form-check-label" htmlFor={`moreFiltersPopularFeatures ${feature}`}>
                        {popularFeaturesForSearch[feature]}
                      </label>
                    </div>
                  )}
                </div>
                {filterSearch.propertyStatus['for-sale'] && <React.Fragment>
                  <div className={`mt-3 ${styles.heading}`}>Sale Method</div>
                  <div className={styles.featureList}>
                    {saleTypes.map((sType, index) =>
                      <div className={`mb-2 ${styles.listItem}`} key={index}>
                        <OdinCheckbox
                          id={`saleType ${sType}`}
                          checked={filterSearch.saleTypes[sType]}
                          onChange={() => updateSaleType(sType)}
                        />
                        <label className="form-check-label" htmlFor={`saleType ${sType}`}>
                          {saleTypeForSearch[sType]}
                        </label>
                      </div>
                    )}
                  </div>
                </React.Fragment>}
                <div className={`mt-3 ${styles.heading}`}>New or Established</div>

                <div className={'d-flex inline'}>
                  <div className={`d-flex mb-2 pr-4 ${styles.moreFiltersAdditionalFilters}`}>
                    <input
                      id="moreFiltersNewAndEstablished"
                      name="newOrEstablished"
                      className="mr-2"
                      type="radio"
                      value="All"
                      checked={!filterSearch.additionalFeaturesQuery.isEstablishedHome &&
                        !filterSearch.additionalFeaturesQuery.isNewBuild}
                      onChange={() => handleNewOrEstablishedChange('All')}
                    />
                    <label className="form-check-label align-content-center" htmlFor="moreFiltersNewAndEstablished">
                      All
                    </label>
                  </div>

                  <div className={`d-flex mb-2 pr-4 ${styles.moreFiltersAdditionalFilters}`}>
                    <input
                      id="moreFiltersIsNewBuild"
                      name="newOrEstablished"
                      className="mr-2"
                      type="radio"
                      value="isNewBuild"
                      checked={filterSearch.additionalFeaturesQuery.isNewBuild}
                      onChange={() => handleNewOrEstablishedChange('isNewBuild')}
                    />
                    <label className="form-check-label align-content-center" htmlFor="moreFiltersIsNewBuild">
                      New Build
                    </label>
                  </div>

                  <div className={`d-flex mb-2 ${styles.moreFiltersAdditionalFilters}`}>
                    <input
                      id="moreFiltersIsEstablishedHome"
                      name="newOrEstablished"
                      className="mr-2"
                      type="radio"
                      value="isEstablishedHome"
                      checked={filterSearch.additionalFeaturesQuery.isEstablishedHome}
                      onChange={() => handleNewOrEstablishedChange('isEstablishedHome')}
                    />
                    <label className="form-check-label align-content-center" htmlFor="moreFiltersIsEstablishedHome">
                      Established Home
                    </label>
                  </div>
                </div>
              </div>
            }

            {filterSearch.propertyStatus['for-rent'] && !filterSearch.propertyStatus['for-sale'] && !filterSearch.propertyStatus['sold'] && !filterSearch.propertyStatus['off-market'] &&
              <div className={styles.searchFilter}>
                <div className={`mt-3 ${styles.heading}`}>Available From</div>
                <div className={'d-inline-flex align-items-center'}>
                  <Datetime closeOnSelect={true} timeFormat={false} dateFormat="DD-MM-YYYY"
                            onChange={(date) => updateDateAvailableFrom(date)}
                            isValidDate={(currentDate) => currentDate.isBetween(moment(), moment().add(2, 'months'), 'days', [])}
                    inputProps={{
                      value: getDateAvailableFrom(),
                      readOnly: true,
                      style: {backgroundColor: '#fff'},
                    }}
                    className={styles.dateTimePickerCustom}
                  />
                  <CloseIcon color={'action'} className={styles.closeButton} onClick={() => updateDateAvailableFrom(null)} />
                </div>
              </div>
            }

            {showHistory &&
              <div className={styles.searchFilter}>
                <div className={styles.heading}>Property History</div>
                <div className={styles.description}>Only show properties with sales and/or rental history. Available for
                  off market properties only.
                </div>
                <div className="d-flex">
                  <div className={styles.featureList}>
                    <div className="d-flex mb-2 mr-3">
                      <OdinCheckbox
                        id="saleHistorySearchFilter"
                        checked={filterSearch.soldHistory}
                        onChange={() => toggleBooleanValue('soldHistory')}
                      />
                      <label className={'form-check-label text-capitalize text-nowrap ' + styles.checkBoxLabel}
                        htmlFor="saleHistorySearchFilter">
                        Sales History
                      </label>
                    </div>
                  </div>
                  <div className={styles.featureList}>
                    <div className="d-flex mb-2 mr-3">
                      <OdinCheckbox
                        id="rentHistorySearchFilter"
                        checked={filterSearch.rentedHistory}
                        onChange={() => toggleBooleanValue('rentedHistory')}
                      />
                      <label className={'form-check-label text-capitalize text-nowrap ' + styles.checkBoxLabel}
                        htmlFor="rentHistorySearchFilter">
                        Rental History
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            }

            {!isHomePage && <div className={styles.searchFilter}>
              <div className={styles.heading}>Additional Filters</div>

              <div className={'d-flex inline'}>
                <div className={`mb-2 pr-4 ${styles.moreFiltersAdditionalFilters}`}>
                  <OdinCheckbox id="moreFiltersIncludeSurroundSuburbs" checked={filterSearch.includeSurroundSuburbs}
                    onChange={() => toggleBooleanValue('includeSurroundSuburbs')}/>
                  <label className="form-check-label" htmlFor="moreFiltersIncludeSurroundSuburbs">Include surrounding
                    areas</label>
                </div>

                {!filterSearch.propertyStatus['off-market'] && !filterSearch.propertyStatus['sold'] &&
                  <div className={`mb-2 ${styles.moreFiltersAdditionalFilters}`}>
                    <OdinCheckbox id="moreFiltersExcludeUnderOffer" checked={filterSearch.excludeUnderOffer}
                      onChange={() => toggleBooleanValue('excludeUnderOffer')}/>
                    {/* eslint-disable-next-line react/no-unescaped-entities */}
                    <label className="form-check-label" htmlFor="moreFiltersExcludeUnderOffer">Exclude 'Under
                      Offer'</label>
                  </div>
                }
              </div>

            </div>}


            {!filterSearch.propertyStatus['off-market'] && !filterSearch.propertyStatus['sold'] &&
              <div className={styles.searchFilter}>
                <div className={styles.heading}>Keyword</div>
                <div className="pr-2">
                  <input className={'p-2 mr-2 ' + styles.addKeywordInputBox}
                    onChange={(e) => setInputKeyword(e.target.value)} placeholder="Add keywords"
                    value={inputKeyword}/>
                  <Button className={`odinButton ${styles.addKeywordBtn} ${disabledKeywordButtonStyle}`}
                    onClick={addKeyword}/>
                </div>
                <div className="d-flex flex-wrap">
                  {filterSearch.additionalFeaturesQuery.featureFreeText.map((value, index) =>
                    <div
                      className={`d-flex justify-content-between align-items-center p-2 mt-2 mr-2 ${styles.keywordCard}`}
                      key={index}>
                      {value}
                      <div className={`ml-2 ${styles.deleteCard}`} onClick={() => deleteKeyword(index)}/>
                    </div>
                  )}
                </div>
              </div>
            }

          </div>
          {!isHomePage && <div className={`w-100 text-center ${styles.viewPropertiesSection}`}>
            <Button className={`odinButton ${styles.viewPropertiesButton}`} onClick={searchFunction}>View
              properties</Button>
          </div>}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

MoreFilters.propTypes = {
  filterSearch: PropTypes.object.isRequired,
  updateSearchFilter: PropTypes.func.isRequired,
  searchFunction: PropTypes.func,
  currentSearch: PropTypes.object,
  isOpen: PropTypes.bool.isRequired,
  toggleFunction: PropTypes.func.isRequired,
  isHomePage: PropTypes.bool,
};

const mapStateToProps = (state) => ({filterSearch: state.filterSearch});
const mapDispatchToProps = {updateSearchFilter};
export default connect(mapStateToProps, mapDispatchToProps)(MoreFilters);
